'use client';

import Image from 'next/image';
import style from './style.module.css';
import { BackToHome } from './back-to-home';
import { FC, useEffect } from 'react';
import { addDDError } from '@wwe-portal/web/libs/analytics/datadog';

export const SomethingWentWrong: FC<{
  error?: Error & { digest?: string };
}> = ({ error }) => {
  useEffect(() => {
    if (error) {
      addDDError(error);
    }
  }, [error]);
  return (
    <div className="relative h-screen overflow-hidden">
      <Image
        fill
        src="/assets/images/common/background.webp"
        alt="background"
        className="object-cover"
      />
      <div className="absolute inset-0 flex flex-col items-center justify-center gap-4">
        <div className={style.title}>Oops, Something Went Wrong, Brother!</div>
        <BackToHome />
      </div>
    </div>
  );
};
